
module dgUtils {

    function propsFilter(): Function {
        return (items, props) => {
            let out = [];

            if (angular.isArray(items)) {
                items.forEach((item) => {
                    let itemMatches = false;

                    let keys = Object.keys(props);
                    for (var i = 0; i < keys.length; i++) {
                        let prop = keys[i];

                        let text = props[prop] ? props[prop].toLowerCase() : "";
                        if (item[prop] && item[prop].toString().toLowerCase().indexOf(text) !== -1) {
                            itemMatches = true;
                            break;
                        }
                    }

                    if (itemMatches) {
                        out.push(item);
                    }
                });
            } else {
                // Let the output be the input untouched
                out = items;
            }

            return out;
        }
    }
    angular.module('dgUtils')
        .filter('propsFilter', propsFilter);
}